import {
  ODataHeader,
  ODataString,
  ODataBoolean,
  ODataDate,
  ODataInteger,
  ODataDecimal,
  HeaderAlignment,
} from "pbas-vue-components";
import {
  translate
} from '../trans'
import store from '@/store'
import { translate2 } from '../trans2'
import { i18n } from '@/plugins/i18n';

export default [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new ODataHeader({
    type: new ODataString("Term/Id"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  
  new ODataHeader({
    title: "headers.hourshistory.employer_contribution_term",
    type: new ODataString("Term/Name", {
      getString: (item) => item.Term.Name + " " + item.Term.Year
    }),
    sortable: true,
    visible: true,
    searchable: true,
    orderByKey: "Term/Name",
    // subHeaders: [
    //   new ODataHeader({
    //     title: "headers.t4a_archive.year",
    //     type: new ODataString("Term/Year"),
    //     sortable: false,
    //     visible: false,
    //     allowVisibilityChange: false,
    //     searchable: true,
    //   }),
    // ]
  }),
  new ODataHeader({
    title: "headers.t4a_archive.year",
    type: new ODataString("Term/Year"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.start_date",
    type: new ODataDate("Term/StartDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.end_date",
    type: new ODataDate("Term/EndDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.hourshistory.total_amount",
    type: new ODataDecimal("TotalAmount"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.hourshistory.total_records",
    type: new ODataInteger("TotalRecords"),
    sortable: false,
    visible: false,
    searchable: false
  }),
  // new ODataHeader({
  //   title: "headers.hourshistory.hours",
  //   type: new ODataDecimal("Amount"),
  //   sortable: true,
  //   visible: true,
  //   searchable: true
  // }),
  // new ODataHeader({
  //   type: new ODataDate("ChangedAt"),
  //   sortable: false,
  //   visible: false,
  //   searchable: false,
  //   allowVisibilityChange: false,
  // }),
  // new ODataHeader({
  //   type: new ODataDate("DeletedAt"),
  //   sortable: false,
  //   visible: false,
  //   searchable: false,
  //   allowVisibilityChange: false,
  // }),
  // new ODataHeader({
  //   title: "headers.hourshistory.reported_at",
  //   type: new ODataDate("CreatedAt", {
  //     getString: (item, type) => {
  //       function parseValue(dateString) {
  //         if (dateString === undefined || dateString === null) {
  //             return "";
  //         }
  //         const [date, time] = dateString.split("T");
  //         const [year, month, day] = date.split("-");
  //         return `${year}-${month}-${day}`;
  //       }
  //       let parsed = "";
  //       if (item.ChangedAt) {
  //         parsed = parseValue(item.ChangedAt);
  //       } else {
  //         parsed = parseValue(item.CreatedAt);
  //       }
  //       return parsed;
  //     }
  //   }),
  //   sortable: true,
  //   visible: true,
  //   searchable: true,
  //   allowVisibilityChange: true,
  // }),
];
